import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { GlobalModule } from '@app/core/global.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { FuiCardComponent } from '@fui/fui-components';
import { DynamicFieldsModule } from '../dynamic-fields/dynamic-fields.module';
import { OrganizeChipsDirective } from './directives/organize-chips.directive';
import { FormFilterComponent } from './form-filter.component';

@NgModule({
    declarations: [FormFilterComponent, OrganizeChipsDirective],
    imports: [GlobalModule, DynamicFieldsModule, ButtonModule, MatChipsModule, FuiCardComponent],
    exports: [FormFilterComponent],
})
export class FormFilterModule {}
